import { request } from '@/shared/api/request'

export const getActualContract = ({ data }) => {
	return request({ url: `contract/sl/actual/contract`, method: 'POST', data: data })
}
